<template>
    <div class="_login">
        <div>
            <h2>
                <img
                    src="../../assets/images/logo.png"
                    alt=""
                    style="height: 26px"
                />
            </h2>
            <el-form
                label-position="left"
                label-width="80px"
                :model="loginForm"
                :rules="rules"
                ref="ruleForm"
                :hide-required-asterisk="true"
            >
                <el-form-item label="Email" prop="email">
                    <el-input v-model="loginForm.email"></el-input>
                </el-form-item>
                <el-form-item label="Password" prop="password">
                    <el-input
                        v-model="loginForm.password"
                        show-password
                    ></el-input>
                </el-form-item>
                <el-form-item class="item-btn">
                    <el-button type="primary" @click="submitForm('ruleForm')"
                        >Log in</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import serverApi from "../../server/index";

export default {
    name: "login",
    data() {
        return {
            loginForm: {
                email: "",
                password: "",
            },
            rules: {
                email: [
                    {
                        required: true,
                        message: "Please input email address!",
                        trigger: "change",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "Please input password!",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log("submit!");
                    this.handleLogin(this.loginForm);
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleLogin(loginParams) {
            serverApi
                .login(loginParams)
                .then((res) => {
                    console.log("login success====>", res);
                    if (res.data.code === 0) {
                        this.$message({
                            message: "login success",
                            type: "success",
                        });
                        this.$store.commit("setUserInfo", {
                            account: loginParams.email,
                            token: res.data.data,
                        });
                        this.$router.replace("/");
                    } else {
                        this.$message({
                            message: res.data.error,
                            type: "error",
                        });
                    }
                })
                .catch((e) => {
                    console.log("login error====>", e);
                    this.$message({
                        message: e.error,
                        type: "error",
                    });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
._login {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    & > div {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: 25px 70px;
        border-radius: 20px;
    }
    h2 {
        text-align: center;
        margin-bottom: 50px;
    }

    
}
</style>